export default __webpack_public_path__ + "static/media/birta_table.3d658825.png";